 ///////////////////////////////////character
 //this array is immediately overwritten in app.js when grabHero('thor'), grabHero('magneto') etc is called
 export const initialCharacterState = {
    result:1,
    lastValues: [],
    character: "Thor",
    description: "Info about Thor",
    headShot: "http://i.annihil.us/u/prod/marvel/i/mg/3/70/5261a838e93c0.jpg",//ultrons so landing page is smooth
    characterID:1009685,
    relatedCharacters:[['1','2','3','4']],
    comicsArray:[
        ['1','2','3','4']
    ],
    comicsReadyToShow:false,
    featuredAreaReadyToShow:false,
    comicsAreaReadyToShow:false,
    featuredComicID:65361,
    showCharacterPopup:false
}

export const characterPageReducer = (state = initialCharacterState,action) => {
    //in this functions case, 'payload' is an array so we access the ata like below
    switch(action.type){
        case "CHANGEHERO":
        state = {
            ...state,//this will grab everything from the previous state
            character: action.payload[0],
            description: action.payload[1],
            headShot: action.payload[2],
            characterID: action.payload[3]
        };
        return state;

        case "CHANGE-FEATURED-COMICS":
        state = {
            ...state,//this will grab everything from the previous state
            comicsArray:action.payload,
            featuredComicID:action.payload[0][3],
        };
        return state;

        case "CHANGE-RELATED-CHARACTERS":
        state = {
            ...state,//this will grab everything from the previous state
            relatedCharacters:action.payload
        };
        return state;
        
        case "SHOW-FEATURED":
        state = {
            ...state,//this will grab everything from the previous state
            featuredAreaReadyToShow:action.payload
        };
        return state;

        case "SHOW-COMICS":
        state = {
            ...state,//this will grab everything from the previous state
            comicsAreaReadyToShow:action.payload
        };
        return state;

        case "SHOW-CHARACTER-POPUP":
        state = {
            ...state,//this will grab everything from the previous state
            showCharacterPopup:action.payload
        };
        return state;
    }
    //reducers always have to return some sort of state
   // console.log(state);
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/characterPageReducer.js